var echarts = require('echarts/lib/echarts');
export default function getData (data) {
    let dataShadow = []
    let len = data.seriesData.length
    // let yMax = Math.max.apply(null, data.seriesData)
    let yMax = 100
    for (var i = 0; i < len; i++) {
      dataShadow.push(yMax);
    }
    return  {
        tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              return params[1].name + ':&nbsp;&nbsp;' + params[1].value + '%'
                    
            }
        },
        xAxis: {
            axisLabel: {
                textStyle: {
                    color: '#fff',
                    fontSize: 10,
                },
                formatter: '{value}%'
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: '#0ff',
                    opacity: 0.1
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#0ff'
                }
            },
            max: 100,
            z: 10
        },
        yAxis: {
            data: data.legendData,
            "axisLine":{       //y轴
                "show": true,
                lineStyle: {
                 color:'#0ff',
                 opacity: 0.15 
                }
              },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 10,
              },
              margin: 2
            }
        },
        grid: {
          top: '2%',
          bottom: '14%',
          left: '34%',
          right: '6%'
        },
        dataZoom: [
            {
                type: 'inside'
            }
        ],
        series: [
            {
                type: 'bar',
                itemStyle: {
                    color: '#0ff',
                    opacity: .05
                },
                barGap: '-100%',
                barCategoryGap: '40%',
                data: dataShadow,
                animation: false,
                barWidth: 10
            },
            {
                type: 'bar',
                label: {
                    show: false,
                    color: '#fff',
                    // position: 'insideRight',
                    position: ['100%', '0%'],
                    formatter: '{c}%'
                },
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(
                        0, 0, 1, 0,
                        [
                            {offset: 0, color: '#0c7ffe'},
                            {offset: 1, color: '#00ffff'}
                        ]
                    )
                },
                emphasis: {
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,
                            [
                                {offset: 1, color: '#0c7ffe'}
                            ]
                        )
                    }
                },
                data: data.seriesData,
                barWidth: 10
            }
        ]
    }
  }


// WEBPACK FOOTER //
// ./src/views/dataIndex/data/powerRanking.js